module.exports = __webpack_public_path__ + "img/baristaart.375f3427.jpg";